
import React from 'react';
import { Plus } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

interface DiscountCode {
  code: string;
  amount: string;
  expires: string;
  usesLeft: number;
}

interface PromoCodesProps {
  discountCodes: DiscountCode[];
  handleAddPromoCode: () => void;
}

const PromoCodes = ({ discountCodes, handleAddPromoCode }: PromoCodesProps) => {
  return (
    <Card className="border border-gray-100 rounded-lg shadow-sm overflow-hidden h-full">
      <div className="bg-gray-50 px-6 py-4 border-b border-gray-100 flex items-center justify-between h-[60px]">
        <h3 className="text-base font-medium text-gray-800">Promo Codes</h3>
        <Button 
          variant="outline" 
          size="sm" 
          onClick={handleAddPromoCode}
          className="flex items-center gap-1 text-sm h-8"
        >
          <Plus size={14} />
          Add New
        </Button>
      </div>
      <CardContent className="p-6">
        {discountCodes.length > 0 ? (
          <div className="space-y-3">
            {discountCodes.map((code, index) => (
              <div key={index} className="flex items-center p-3 bg-gray-50 rounded-md">
                <div className="px-2 py-1 bg-blue-100 text-blue-600 rounded text-xs font-medium mr-3">
                  {code.code}
                </div>
                <div className="flex-1">
                  <div className="text-sm font-medium">{code.amount}</div>
                  <div className="text-xs text-gray-500">
                    Expires: {code.expires} • Uses left: {code.usesLeft}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-sm text-gray-500">No promo codes available.</p>
        )}
      </CardContent>
    </Card>
  );
};

export default PromoCodes;
